import { getApiClient } from "../http/client";
import type { DataResponse, RequestOptions } from "../http/types";
import type { WeatherTimeGroupResponse } from "../weather/types";
import type { WorkerSiteResponse } from "./types";

// `no-store` 가 없으면 현장 UUID 를 바꿔 들어왔을 때 이전 현장 응답이 그대로 나온다.
const PUBLIC: RequestOptions = { auth: "public", cache: "no-store" };

async function getWorkerSite(uuid: string): Promise<WorkerSiteResponse> {
  const res = await getApiClient().get<DataResponse<WorkerSiteResponse>>(
    `/workers/sites/${uuid}`,
    PUBLIC
  );
  return res.data;
}

async function getWorkerWeather(uuid: string): Promise<WeatherTimeGroupResponse[]> {
  const res = await getApiClient().get<DataResponse<WeatherTimeGroupResponse[]>>(
    `/workers/sites/${uuid}/weather`,
    PUBLIC
  );
  return res.data ?? [];
}

async function registerWorkerFcmToken(uuid: string, token: string): Promise<void> {
  await getApiClient().post<void>(
    `/workers/sites/${uuid}/push/subscriptions`,
    { token, deviceLabel: navigator.userAgent },
    PUBLIC
  );
}

export const workerService = {
  getWorkerSite,
  getWorkerWeather,
  registerWorkerFcmToken,
};
